import { useErrors } from '@auth0/auth0-acul-react/mfa-sms-challenge';
import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import InfoBlock3 from 'creative-ui/uikit/InfoBlock3';
import SvgCheckMark from 'creative-ui/uikit/svg/check-mark';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { AuthErrorBanner } from '@/components/AuthErrorBanner/AuthErrorBanner';
import ContactAdvisorModal from '@/components/ContactAdvisorModal/ContactAdvisorModal';
import { useTrackErrors } from '@/hooks/useTrackErrors';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { commonTransComponents } from '@/i18n/translationsComponents';
import { trackPageView } from '@/lib/tagging';

import MfaSmsChallengeForm from './components/MfaSmsChallengeForm';
import { useMfaSmsChallengeManager } from './hooks/useMfaSmsChallengeManager';

function MfaSmsChallengeScreen() {
  const { t } = useTranslation('mfaSmsChallenge');
  useTransactionLocale();

  const { texts, phoneNumber, isLoginChallenge } = useMfaSmsChallengeManager();

  const { errors } = useErrors();
  const { generalErrorMessages, fieldErrors } = useTrackErrors(
    errors,
    'mfa/sms/error',
  );

  // Tagging base path depends on context: login challenge vs enrollment verification
  const basePath = isLoginChallenge ? 'login/sms/code' : 'mfa/sms/verification';

  useEffect(() => {
    trackPageView(basePath);
  }, [basePath]);

  // SDK first, i18n fallback
  document.title = texts?.pageTitle || t('page.title');

  const title = texts?.title || t('header.title');
  const codeSentTitle = t('header.codeSentTitle');

  return (
    <BaseWrapper title={title}>
      <InfoBlock3
        className="u-margin-b-l"
        title={codeSentTitle}
        color="green"
        svgComp={SvgCheckMark}
        box
        border>
        <Trans
          i18nKey="header.codeSentMessage"
          t={t}
          values={{ phoneNumber }}
          components={commonTransComponents}
        />
      </InfoBlock3>
      <AuthErrorBanner errors={generalErrorMessages} />
      <MfaSmsChallengeForm fieldErrors={fieldErrors} />
      <ContactAdvisorModal
        className="u-margin-form"
        ctaLabel={t('modalContact.ctaLabel')}
      />
    </BaseWrapper>
  );
}

export default MfaSmsChallengeScreen;
